var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWeight)?_c('span',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.__('Weight')}},[_c('gl-icon',{attrs:{"name":"weight","size":12}}),_vm._v("\n  "+_vm._s(_vm.weight)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }